import React from "react";
import {MdError} from "react-icons/md";
import {useLocation} from "react-router-dom";

const Error=()=>{
    const {state} = useLocation();

    const message=state?state.message:"";
    return      <div className="   w-full  ">

        <div className="w-11/12 md:w-6/12 lg:w-4/12 bg-red-100 border p-4  justify-center items-center flex flex-col mx-auto mt-20  rounded-2xl">
            <MdError className="text-5xl text-red-500 mb-3"/>
            <div className="w-full p-3  ">   <div><h1 className=" text-center text-red-500 font-bold mb-1 text-2xl">خطا</h1></div>
                <div><p className=" font-light text-center text-red-500  mb-5 ">{message}</p></div>
                </div>
        </div>
    </div>

}
export default Error;